export default "__VITE_ASSET__g1wmDPRL__"